<template>
  <div class="default-layout">
    <v-container fluid>
      <div class="container-content">
        <v-row>
          <v-col cols="auto" style="min-width: 60px">
            <c-nav-drawer
              @logout="logout()"
            />
          </v-col>

          <v-col cols="auto" style="min-width: calc(100% - 62px)">
            <!-- Контент -->
            <slot />
            <!-- Контент END -->
          </v-col>
        </v-row>
      </div>
    </v-container>
    <c-icon-include />

    <c-handler-error>
      <template #error="{ props_error }">
        <c-message
          v-show="props_error.network"
          class="error white--text"
          message="Помилка підключення до мережі"
        />
      </template>
    </c-handler-error>
  </div>
</template>

<script>
import cHandlerError from '@/components/base/c-handler-error'
import cMessage from '@/components/base/c-message'
import cNavDrawer from '@/components/base/c-nav-drawer'
import cIconInclude from '@/components/base/c-icon-include'

export default {
  name: 'DefaultLayout',
  components: {
    cHandlerError,
    cMessage,
    cNavDrawer,
    cIconInclude
  },
  data() {
    return {
      dropdownMenu: false
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('AUTH_LOGOUT_REQUEST')
      .finally(() => {
        setTimeout(() => {
          // this.$store.commit('RECT_RESET_ALL_STATE')
          // this.$store.commit('SETTINGS_UI_RESET')
          this.$router.push('/login')
        }, 150)
      })
    }
  }
}
</script>

<style lang="scss">
  .default-layout .link {
    text-decoration: none;
    color: inherit;
  }
 .container-content {
    min-height: calc(100vh - 90px);
 }
</style>